"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerBlockStyles = exports.confirmBlockStyles = exports.applyFormStyles = exports.formBlockStyles = void 0;
var formBlockStyles = {
    paddingSpace: {
        padding: '1em 2em',
    },
    titleBox: {
        borderTop: 'solid 1px',
        padding: '0.5em 2em',
        borderBottom: 'solid 1px',
        borderColor: 'primary.main',
        color: 'secondary.main',
    },
    closeButton: {
        position: 'absolute',
        left: '-24px',
        top: '26px',
        opacity: '0.9',
        bgcolor: 'black',
        color: 'white',
    },
    dialogPaper: {
        width: { xs: '100%', md: '70%' },
        flexDirection: 'row',
        overflow: 'visible',
    },
};
exports.formBlockStyles = formBlockStyles;
var applyFormStyles = {
    uploadButton: {
        mt: 2,
        mb: 2,
    },
    applyVacancy: {
        '& > label': {
            px: 4,
            py: 3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 'fit-content',
            color: 'white',
            backgroundColor: function (theme) { return theme.palette.secondary.main; },
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '1.25rem',
            fontWeight: 700,
        },
    },
    applyVacancyHasFile: {
        '& > label': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            px: 4,
            py: 3,
            display: 'inline-block',
            maxWidth: { xs: '100%', md: '240px' },
            verticalAlign: 'middle',
            color: 'white',
            backgroundColor: function (theme) { return theme.palette.secondary.main; },
            borderRadius: '50px',
            cursor: 'pointer',
            fontSize: '1.25rem',
            fontWeight: 700,
        },
    },
    buttons: {
        display: 'flex',
        padding: '0em 1em',
        gap: '2em',
    },
    buttonsMobile: {
        display: 'flex',
        padding: '0em 1em',
        flexDirection: 'column',
        '> button': {
            mt: 4,
        },
    },
    quill: {
        mt: 1,
        '& .ql-editor': {
            minHeight: '150px',
        },
        '& .ql-tooltip': {
            left: 'auto !important',
        },
    },
    tipBox: {
        mt: 4,
        border: 'solid 1px',
        borderRadius: '6px',
        borderColor: function (theme) { return theme.palette.primary.main; },
        flexDirection: { xs: 'column', md: 'row' },
    },
    tipBoxIcon: {
        display: 'flex',
        flexDirection: { xs: 'row', md: 'column' },
        justifyContent: { xs: 'flex-start', md: 'center' },
        alignItems: 'center',
        textAlign: 'center',
        fontWeight: 'bold',
        color: 'white',
        background: 'linear-gradient(84.06deg, rgba(0, 0, 0, 0.9) 0%, rgba(64, 64, 64, 0.9) 100%)',
        padding: { xs: '0.5em 1em', md: '1.5em 1em' },
        borderRadius: '6px 0px 0px 6px',
        borderRight: 'solid 1px',
        borderColor: function (theme) { return theme.palette.primary.main; },
    },
    tipBoxText: {
        padding: { xs: '0.5em 1em', md: '1.5em 1em' },
        width: '100%',
    },
};
exports.applyFormStyles = applyFormStyles;
var registerBlockStyles = {
    label: {
        color: 'black',
        fontWeight: '500',
    },
    textField: {
        backgroundColor: '#F4F2F4',
        mt: '2px',
        '& > .MuiFormHelperText-root': {
            bgcolor: 'white',
            marginRight: 0,
            marginLeft: 0,
        },
    },
    buttons: {
        gap: '2em',
        textAlign: 'center',
        justifyContent: 'center',
    },
    buttonsMobile: {
        flexDirection: 'column',
        gap: '0.5em',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'stretch',
    },
};
exports.registerBlockStyles = registerBlockStyles;
var confirmBlockStyles = {
    block: {
        border: 'solid 1px',
        borderRadius: '0px 6px 6px 0px',
        borderColor: function (theme) { return theme.palette.primary.main; },
        backgroundColor: '#F4F2F4',
        flexBasis: '50%',
    },
    mobileBlock: {
        color: 'white',
        background: 'linear-gradient(84.06deg, rgba(0, 0, 0, 0.9) 0%, rgba(64, 64, 64, 0.9) 100%)',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        fontSize: '1.1em',
        fontWeight: 'bold',
        padding: 2,
    },
    headingBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: 'white',
        background: 'linear-gradient(84.06deg, rgba(0, 0, 0, 0.9) 0%, rgba(64, 64, 64, 0.9) 100%)',
        padding: '1.5em 1em',
        borderRight: 'solid 1px',
        borderColor: function (theme) { return theme.palette.primary.main; },
    },
    headingBlockMobile: {
        display: 'flex',
        color: 'white',
        background: 'linear-gradient(84.06deg, rgba(0, 0, 0, 0.9) 0%, rgba(64, 64, 64, 0.9) 100%)',
        fontWeight: 'bold',
    },
    textBlock: {
        padding: '1.5em 1em',
        width: '100%',
        '& > h4': {
            color: function (theme) { return theme.palette.primary.dark; },
            margin: '0.5em 0 0.5em 0',
            fontSize: '20px',
        },
    },
};
exports.confirmBlockStyles = confirmBlockStyles;
